<template>
    <v-sheet style="background-color:#FFF;height:100%">
        <v-toolbar floating elevation="0" style="border-bottom:1px solid #ddd" pb-5>
                <v-toolbar-title>OBRAS</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <template v-if="$vuetify.breakpoint.smAndUp">
                        <v-btn :to="{name:'work_add'}" text color="primary">
                            <v-icon>add</v-icon>&nbsp; OBRA
                        </v-btn>
                    </template>
                    <template v-if="!$vuetify.breakpoint.smAndUp">
                        <v-btn :to="{name:'work_add'}" text color="primary">
                            <v-icon>add</v-icon>&nbsp; OBRA
                        </v-btn>
                    </template>
                </v-toolbar-items>
            </v-toolbar>

    <v-layout wrap style="height:100%">       
        <v-container fill-height v-if="load_feito && works.length == 0" >
            <v-flex xs12 >
                <v-layout text-center align-center justify-center>
                    <v-flex xs12>
                        <h1 class="display-1 mb-5">
                            <span class="font-weight-bold">As obras musicais</span> são importantes
                        </h1>
                        <p class="subheading font-weight-regular my-5">
                            Cadastre primeiro as obras musicais que fazem parte do seu produto para depois montar o seu Single, EP ou Álbum.
                        </p>
                        <p class="subheading font-weight-regular my-5">
                            É muito importante que você cadastre as informações das obras musicais corretamente, porque só assim os compositores receberão seus direitos autorais.
                        </p>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-container>

        <v-flex xs12 px-3 py-5 v-if="load_feito && works.length > 0">
            <v-layout>
                <v-flex xs12>
                    <v-card elevation="0">
                        <v-card-title>
                            <div class="flex-grow-1"></div>
                            <v-text-field
                                v-model="search"
                                append-icon="search"
                                label="Minhas obras"
                                single-line
                                hide-details
                            ></v-text-field>
                        </v-card-title>
                        <v-data-table 
                        :headers="headers" 
                        :items="works" 
                        :search="search" 
                        no-results-text="Sem resultados para essa busca" 
                        text 
                        
                        sortByText="Ordenar"
                        >
                            <template v-slot:item.action="{ item }">
                                <v-menu offset-y >
                                    <template v-slot:activator="{ on }">
                                        <v-btn color="primary" dark v-on="on" icon>
                                            <v-icon>more_vert</v-icon>
                                            <!-- $vuetify.dataTable.sortBy -->
                                        </v-btn>
                                    </template>
                                    <v-list dense>
                                        <v-list-item :to="{name:'work_edit',params:{id:item.id}}">
                                            <v-list-item-title>Editar</v-list-item-title>
                                        </v-list-item>
                                        <!--v-list-item>
                                            <v-list-item-title>Deletar</v-list-item-title>
                                        </v-list-item-->
                                    </v-list>
                                </v-menu>
                               
                            </template>
                            <template v-slot:no-data>
                                <v-btn color="primary" @click="initialize">Reset</v-btn>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>

    </v-sheet>
</template>

<script>
import WorkService from "../../../app/Rest/work";
var workService = null;

export default {
    data: () => ({
        works: [],
        load_feito: false,
        search: "",
        headers: [
            {
                text: "Titulo",
                align: "left",
                sortable: true,
                value: "name"
            },
            //{ text: "ISWC", value: "iswc" },
            { text: "Versão", value: "version_name" },
            { text: "Compositores", value: "composer_string" },
            { text: "Ações", value: "action", sortable: false }
        ]
    }),
    beforeCreate(){
         this.$vuetify.dataTable = {sortByText: "Ordenar por"}
    },
    mounted() {
       
        this.$store.commit("loading");
        workService = WorkService.build();
        workService
            .getAll()
            .then(e => {
                this.works = e.items.map(obra => {
                    if (obra.composers.length == 0) {
                        let _c = JSON.parse(obra.own_rights_info);
                        //console.log(_c);
                        if (_c.composers) {
                            obra.composers = _c.composers;
                            obra.composer_string = _c.composers
                                .map(i => {
                                    return i.name;
                                })
                                .join(",");
                        }
                    }

                    return obra;
                });
                //console.log("works->");
                //console.log(this.works);
            })
            .finally(() => {
                this.load_feito = true;
                this.$store.commit("loading", false);
            });
    }
};
</script>
